// istanbul ignore file
export const loadProtobufClientProperties = () =>
  import(/* webpackChunkName: "4-feat-protobuf-client-properties" */ './getProtobufClientProperties');
export const loadProtobufRequestFunctions = () =>
  import(/* webpackChunkName: "4-feat-protobuf-request" */ './protobufRequestFunctions');
